<div class="container-fluid container-fluid--tab">
  <form #form="ngForm" (submit)="saveCustomFieldsPerTab(dateEffectiveModal)">
    <div *ngIf="loading">
      <div style="position: absolute; top: 0; bottom: 0; left: 0; right: 0">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHRSURBVEhLYxjygBFKEwW2vHz2v+n2NYanP74zaPHwMfiISzKES8oySHBw4jSHKAte/Pj+v/bWVYbZj+5BRRBAmoOToV5ViyFNXhmrWQQtmPXw7v9GqKvxgQJFVYYJ2oYY5uG04PzH9//Lrl9i2P3mJVSEMGhW12GoVdVCMRPDgq9//vxvv3uDoe/eTYZvf/9CRYkDLIyMDKdtXBgM+QXh5jJBaTAARaL50b0MLcAgIdVwEPjz/z9D250bUB4EwC2ouXnlv8/pIwxXPn+EipAH9gCDFJQooFyEBfMf34eyKAPvf/9iuPn1C5SHZAE5QYILPPz+FcpCiwNaALgFXMzMUBblQIiVDcpCsgCUI6kBmIFJVZGLG8pDssBNVALKogxoAssoZS4eKA/JggQZeaoEU56CCgMHMzNmRlPh5mWsVNGE8sgDZgJCDHEyClAeBMAtAIEaZXWGUGDxSw4AxeF8fVMU14MAigWMTMyMiw3MGFLllKAixAGQy3eZ2zFo8/JjlG0YAjAAKpcm3r/NcPDda4Zf//5BRVGBDi8/0DGKDCmySgzcLCxYzcJpAQxc/fzx/9mP7xluAbP/lz+/wWKgZGjAJ8hgDnQ5epCMAhIBAwMAkZCFkdRkDGMAAAAASUVORK5CYII="
          class="fa-spin"
          style="width: 24px; margin: 0; position: absolute; left: 50%; top: 50%; transform: translate3d(-12px, -12px, 0)"
        />
      </div>
    </div>

    <div *ngIf="!loading && vm">
      <ng-container *ngIf="vm.categories?.length > 0">
        <div class="row">
          <div class="col-12 mb-3">
            <div class="d-flex">
              <div class="flex-grow-1 text-end" *ngIf="canEdit">
                <button *ngIf="saving" type="button" class="btn btn-outline">
                  <i class="fas fa-sync-alt fa-spin"></i>
                  {{ 'saving' | label : 'general' | async }}
                </button>
                <button *ngIf="!saving && !pendingChanges" type="button" class="btn btn-green" (click)="saveCustomFieldsPerTab(dateEffectiveModal)">
                  <i class="fas fa-check"></i>
                  {{ 'savedsuccessfully' | label : 'general' | async }}
                </button>
                <button *ngIf="!saving && pendingChanges" type="button" (click)="saveCustomFieldsPerTab(dateEffectiveModal)" class="btn btn-outline-danger">
                  <i class="fas fa-exclamation-triangle text-danger"></i>
                  {{ 'unsaved_changes' | label : 'general' | async }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="h2-content">
          <app-custom-field-content-form
            [vm]="vm"
            [showLogButtons]="true"
            [showDateEffectiveBadges]="true"
            fieldLabelColumnClass="col-3"
            fieldControlColumnClass="col-5"
            rowClass="row mb-3 align-items-center"
            (valueChanged)="markPendingChanges()"
            (viewLogClicked)="viewLog(logModal, $event)">
          </app-custom-field-content-form>
        </div>
      </ng-container>
    </div>
  </form>
</div>

<ng-template #logModal let-modal>
  <ng-container *ngIf="logField">
    <div class="modal-header">
      <h2 class="modal-title">{{ 'log_of_field' | label : 'custom_fields' | async }} "{{ logField.name }}"</h2>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div *ngIf="loadingLog" class="text-center py-5">
        <i class="fas fa-sync-alt fa-spin me-2"></i>
        {{ 'loading' | label : 'general' | async }}
      </div>

      <div *ngIf="!loadingLog && logField.fieldType != FieldType.Composite && scalarLog">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <div class="d-flex align-items-center log--table header" [ngClass]="{ 'has-date-effective': logField.useDateEffective }">
              <div class="log-action">{{ 'action' | label : 'flowgenerator' | async }}</div>
              <div class="log-date">{{ 'date_of_change' | label : 'custom_fields' | async }}</div>
              <div class="log-actor">{{ 'actor' | label : 'general' | async }}</div>
              <div class="log-old-value">{{ 'old_log' | label : 'log' | async }}</div>
              <div class="log-new-value">{{ 'new_log' | label : 'log' | async }}</div>
              <div class="log-date-effective" *ngIf="logField.useDateEffective">{{ 'dateeffective' | label : 'pan' | async }}</div>
            </div>
          </li>
        </ul>

        <ul class="list-group mb-5">
          <ng-container *ngFor="let log of scalarLog.rows">
            <li class="list-group-item list-group-item-action">
              <div class="d-flex align-items-center log--table" [ngClass]="{ 'has-date-effective': logField.useDateEffective }">
                <div class="log-action">
                  <ng-container [ngSwitch]="log.logKind">
                    <span *ngSwitchCase="LogKind.Add">{{ 'added' | label : 'custom_fields' | async }}</span>
                    <span *ngSwitchCase="LogKind.Edit">{{ 'modified' | label : 'custom_fields' | async }}</span>
                    <span *ngSwitchCase="LogKind.Delete">{{ 'deleted' | label : 'custom_fields' | async }}</span>
                  </ng-container>
                </div>

                <div class="log-date">{{ log.createdDate | employeeDate | async }}</div>
                <div class="log-actor text-truncate">{{ log.creator }}</div>
                <div class="log-old-value text-truncate"><span [innerHTML]="getLogValueAsLabel(logField, log.oldValue)"></span></div>
                <div class="log-new-value text-truncate"><span [innerHTML]="getLogValueAsLabel(logField, log.newValue)"></span></div>
                <div class="log-date-effective" *ngIf="logField.useDateEffective">{{ log.newDateEffective | employeeDate | async }}</div>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>

      <div *ngIf="!loadingLog && logField.fieldType == FieldType.Composite && compositeLog">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <div class="d-flex align-items-center log--table header" [ngClass]="{ 'has-date-effective': logField.useDateEffective }">
              <div class="log-collapse">
                <i class="me-2 far fa-fw cursor-pointer" [ngClass]="compositeLogsAllCollapsed ? 'fa-plus-square' : 'fa-minus-square'" (click)="toggleAllCompositeLogs()"></i>
              </div>
              <div class="log-action">{{ 'action' | label : 'flowgenerator' | async }}</div>
              <div class="log-date">{{ 'date_of_change' | label : 'custom_fields' | async }}</div>
              <div class="log-actor">{{ 'actor' | label : 'general' | async }}</div>
              <div class="log-date-effective" *ngIf="logField.useDateEffective">{{ 'dateeffective' | label : 'pan' | async }}</div>
            </div>
          </li>
        </ul>

        <ul class="list-group mb-5">
          <ng-container *ngFor="let compositeGroup of compositeLog.groups">
            <li class="list-group-item list-group-item-action" [ngClass]="{ 'list-group-item-secondary': !compositeGroup.collapsed }">
              <div class="d-flex align-items-center log--table" [ngClass]="{ 'has-date-effective': logField.useDateEffective }">
                <div class="log-collapse">
                  <i class="me-2 far fa-fw cursor-pointer" [ngClass]="compositeGroup.collapsed ? 'fa-plus-square' : 'fa-minus-square'" (click)="toggleCompositeLog(compositeGroup)"></i>
                </div>

                <div class="log-action">
                  <ng-container [ngSwitch]="compositeGroup.logKind">
                    <span *ngSwitchCase="LogKind.Add">{{ 'added' | label : 'custom_fields' | async }}</span>
                    <span *ngSwitchCase="LogKind.Edit">{{ 'modified' | label : 'custom_fields' | async }}</span>
                    <span *ngSwitchCase="LogKind.Delete">{{ 'deleted' | label : 'custom_fields' | async }}</span>
                  </ng-container>
                </div>

                <div class="log-date">{{ compositeGroup.createdDate | employeeDate | async }}</div>
                <div class="log-actor text-truncate">{{ compositeGroup.creator }}</div>
                <div class="log-date-effective" *ngIf="logField.useDateEffective">{{ compositeGroup.dateEffective | employeeDate | async }}</div>
              </div>

              <div class="custom-field-log-detail mt-3" *ngIf="!compositeGroup.collapsed">
                <ul class="list-group">
                  <li class="list-group-item">
                    <div class="d-flex align-items-center log--table header">
                      <div class="detail-field-name">{{ 'name_field' | label : 'custom_fields' | async }}</div>
                      <div class="detail-old-value">{{ 'old_log' | label : 'log' | async }}</div>
                      <div class="detail-new-value">{{ 'new_log' | label : 'log' | async }}</div>
                    </div>
                  </li>

                  <li class="list-group-item" *ngFor="let cell of compositeGroup.cells">
                    <div class="d-flex align-items-center log--table">
                      <div class="detail-field-name text-truncate">{{ cell.childFieldName }}</div>
                      <div class="detail-old-value text-truncate"><span [innerHTML]="getLogValueAsLabel(getCompositeLogChildField(cell.childFieldId), cell.oldValue)"></span></div>
                      <div class="detail-new-value text-truncate"><span [innerHTML]="getLogValueAsLabel(getCompositeLogChildField(cell.childFieldId), cell.newValue)"></span></div>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #dateEffectiveModal let-modal>
  <ng-container *ngIf="fieldsWithChangedValueAndDateEffective?.length > 0 || changedCompositeRowsWithDateEffective?.length > 0">
    <form #formDateEffective="ngForm">
      <div class="modal-header">
        <h2 class="modal-title">{{ 'setting_date_effective_for_data_changes' | label : 'custom_fields' | async }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <div class="row mb-2 align-items-center">
          <div class="col-2">
            <strong>{{ 'name_field' | label : 'custom_fields' | async }}</strong>
          </div>
          <div class="col-6">
            <strong>{{ 'new_log' | label : 'log' | async }}</strong>
          </div>
          <div class="col-4">
            <strong>{{ 'dateeffective' | label : 'pan' | async }}</strong>
          </div>
        </div>

        <div *ngFor="let field of fieldsWithChangedValueAndDateEffective; trackBy: trackFields; let i = index">
          <div class="row mb-2 align-items-center">
            <div class="col-2">
              <label class="col-form-label">{{ field.name }}</label>
            </div>
            <div class="col-6">{{ getFieldPreviewValue(field) }}</div>
            <div class="col-4" *ngIf="field.scalarValue">
              <app-datepicker id="fielddateeffective{{ i }}" [date]="field.scalarValue.dateEffective" (dateChange)="field.scalarValue.dateEffective = $event" [inline]="true" [simple]="true" [marginBottom]="false" [small]="true" [required]="true"></app-datepicker>
            </div>
          </div>
        </div>

        <div *ngFor="let entry of changedCompositeRowsWithDateEffective; let i = index">
          <div class="row mb-2 align-items-center">
            <div class="col-2">
              <label class="col-form-label">{{ entry.field.name }}</label>
            </div>
            <div class="col-6">
              <div *ngFor="let previewLine of getCompositeRowPreview(entry.field, entry.row)">{{ previewLine }}</div>
            </div>
            <div class="col-4">
              <app-datepicker id="fielddateeffectivecomposite{{ i }}" [date]="entry.row.dateEffective" (dateChange)="entry.row.dateEffective = $event" [inline]="true" [simple]="true" [marginBottom]="false" [small]="true" [required]="true"></app-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="modal.dismiss()">
          {{ 'cancel' | label : 'general' | async }}
        </button>
        <button type="button" class="btn btn-progreso" (click)="modal.close()" [disabled]="formDateEffective.invalid">
          {{ 'save' | label : 'general' | async }}
        </button>
      </div>
    </form>
  </ng-container>
</ng-template>
